import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-textcounter', 'remaining', 'tähemärki');
Labels.set('ui-textcounter', 'invalid', 'Kasuta kuni %d tähemärki.');
